import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Button } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import styles from './VendorAttribution.module.css';

const useStyles = makeStyles()((theme) => ({
  selected: {
    color: 'white',
    background: get(theme, 'palette.primary.main'),
    '&:hover': {
      background: get(theme, 'palette.primary.dark'),
    },
    '&.Mui-disabled': {
      backgroundColor: get(theme, 'palette.disableGray.dark'),
      color: 'white',
    },
  },
  notSelected: {
    color: get(theme, 'palette.disableGray.main'),
    background: get(theme, 'palette.bg.main'),
  },
  yes: {
    width: '105px',
    borderRadius: '4px 0px 0px 4px',
  },
  no: {
    width: '105px',
    borderRadius: '0px 4px 4px 0px',
  },
}));

export default function ButtonSwitch(props) {
  const { classes, cx } = useStyles();
  const {
    onChange,
    disabled = false,
    selected = null,
    left = 'yes',
    leftLabel = 'Yes',
    right = 'no',
    rightLabel = 'No',
  } = props;

  function toggle(isSelected) {
    onChange(isSelected);
  }

  function selectIndicator(bool) {
    if (selected === null) return false;
    if ((selected && bool) || (!selected && !bool)) return true;
    return false;
  }

  return (
    <div className={styles.switchContainer}>
      <Button
        disabled={disabled}
        className={cx(classes.yes, {
          [classes.notSelected]: !selectIndicator(true),
          [classes.selected]: selectIndicator(true),
        })}
        variant="contained"
        name="yes"
        value={left}
        onClick={() => toggle(true)}
      >
        {leftLabel}
      </Button>
      <Button
        disabled={disabled}
        className={cx(classes.no, {
          [classes.notSelected]: !selectIndicator(false),
          [classes.selected]: selectIndicator(false),
        })}
        variant="contained"
        name="no"
        value={right}
        onClick={() => toggle(false)}
      >
        {rightLabel}
      </Button>
    </div>
  );
}

ButtonSwitch.propTypes = {
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  left: PropTypes.string,
  leftLabel: PropTypes.string,
  right: PropTypes.string,
  rightLabel: PropTypes.string,
};
